import React from 'react';
import { COLORS_CONSTANTS } from '../../constants/Colors';
import { FONTS } from '../../constants/Fonts';

/**
 * GradientText component
 * @param {string} text - The text to display
 * @param {string} fontFamily - The font family to use (e.g., FONTS.MONTSERRAT_BOLD)
 * @param {number|string} fontWeight - The font weight (e.g., 700)
 * @param {number} fontOpacity - Opacity for the text (0-1)
 * @param {string|number} fontSize - Font size (e.g., '24px', 24)
 * @param {string|number} letterSpacing - Letter spacing (e.g., '2px', 2)
 * @param {object} style - Additional style overrides
 */

export default function GradientText({
    text,
    hintText,
    fontFamily = FONTS.MONTSERRAT_SEMIBOLD,
    fontWeight,
    fontOpacity = 1,
    fontSize = 24,
    letterSpacing = 0,
    backgroundColor,
    textColor = COLORS_CONSTANTS.PAGE_TEXT,
    gradientColor1,
    gradientColor2,
    style = {},
}) {
    // Determine background and text styles
    let spanStyle = {
        fontFamily,
        fontWeight,
        opacity: fontOpacity,
        fontSize,
        letterSpacing,
        display: 'inline-block',
        backgroundColor: backgroundColor ? backgroundColor : 'transparent',
        ...style,
    };

    if (gradientColor1 && gradientColor2) {
        // Use gradient only with backgroundImage, avoid background shorthand
        spanStyle.backgroundImage = `linear-gradient(180deg,#FFF6B3 0%,${gradientColor1} 45%,${gradientColor2} 100%)`;
        spanStyle.WebkitBackgroundClip = 'text';
        spanStyle.WebkitTextFillColor = 'transparent';
        spanStyle.backgroundClip = 'text';
        // Remove background property if present
        if (spanStyle.background) delete spanStyle.background;
    } else {
        // Use solid text color, no gradient
        spanStyle.color = textColor;
        // Remove gradient-related properties
        if (spanStyle.backgroundImage) delete spanStyle.backgroundImage;
        spanStyle.WebkitBackgroundClip = 'initial';
        spanStyle.WebkitTextFillColor = 'initial';
        spanStyle.backgroundClip = 'initial';
    }

    return (
        <span style={spanStyle}>
            {text}
        </span>
    );
}
